import { Component, Input } from "@angular/core";
import { TaskRunSummary, TaskStatusType, TaskSummary } from "@apiserver-rest/ponder-tasks-client-base";
import { ColorDictionary } from "@ponder-shared/utils/colors";
import { formatDate } from "@ponder-shared/utils/general";

@Component({
    selector: "task-summary-row",
    imports: [],
    templateUrl: "./task-summary-row.component.html"
})
export class TaskSummaryRowComponent {
    @Input({ required: true }) public taskName!: string;
    @Input({ required: true }) public taskSummaries?: TaskSummary[];

    public taskSummary?: TaskSummary;
    public lastRun?: string;

    public constructor() {

    }

    public ngOnInit(): void {
        this.taskSummary = this.getTaskSummary();
        this.taskSummary?.recent?.sort((a, b) => (a.start.getTime() - b.start.getTime()));

        this.lastRun = this.getLastRun();
    }

    private getTaskSummary(): TaskSummary | undefined {
        if (!this.taskSummaries) {
            return undefined;
        }

        for (let summary of this.taskSummaries) {
            if (summary.task == this.taskName) {
                return summary;
            }
        }

        return undefined;
    }

    private getLastRun(): string {
        if (!this.taskSummary || !this.taskSummary.recent) {
            return "";
        }
        
        return formatDate(this.taskSummary.recent[this.taskSummary.recent.length - 1].start);
    }


    public getRunColor(run: TaskRunSummary): string {
        switch (run.status) {
            case TaskStatusType.Success:
                return ColorDictionary.StatusGreen;

            case TaskStatusType.Failure:
                return ColorDictionary.StatusRed;

            case TaskStatusType.Cancelled:
                return ColorDictionary.StatusOrange;

            // shouldn't get here as the endpoint _should_ only return completed tasks.
            default:
                return ColorDictionary.StatusGray;
        }
    }

    /**
     * @returns A color based on how many recent run failures there have been. Red >= 3, Orange > 1, Green if none.
     */
    public getSummaryColor(): string {
        if (this.taskSummary?.recent) {
            var recentFailCount = 0;

            this.taskSummary.recent.forEach(r => {
                if (r.status != TaskStatusType.Success) {
                    recentFailCount++;
                }
            });

            if (recentFailCount == this.taskSummary.recent.length) {
                return ColorDictionary.StatusRed;
            }

            return (recentFailCount >= 3 ? ColorDictionary.StatusRed : 
                    recentFailCount >= 1 ? ColorDictionary.StatusOrange : ColorDictionary.StatusGreen);
        } else {
            return ColorDictionary.StatusGray;
        }
    }
}